/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import 'babel-polyfill'
import React from 'react'
import F2AppContainer from '../../../../F2AppContainer'
import { APP_IDS, EVENT_NAMES } from '../../../../../../utils/f2Constants'
import TokenEvents from '../../../TokenEvents'
import Tabs from '../../../../../Lib/Tabs/Tabs'
import stylesQuoteResearch from './Valuations.module.scss'
import SymbolSearch from '../../../../../Lib/SymbolSearch/SymbolSearch'
import { registerF2OnEvent, emitF2Event } from '../../../../../../utils/f2Methods'
import { changeTabHandler, getSymbolFromPath } from '../../../../utils'

class Valuations extends React.Component {
  constructor (props) {
    super(props)
    this.symbolRecvd = this.props.match.params.symbol
    this.state = {
      symbol: 'MSFT',
      period: 'Annual'
    }
  }

  componentDidMount () {
    registerF2OnEvent(EVENT_NAMES.MOD_GOTO, (modGotoContext) => {
      emitF2Event(EVENT_NAMES.SYMBOL_CHANGED_EVENT, {symbol: modGotoContext.symbol})
    })
  }

  render () {
    return (
      <div data-page='F2AppContainer'>
        <div className={stylesQuoteResearch.header}>
          <span>Quotes & Research</span>

        </div>
        <div>
          <F2AppContainer
            appId={APP_IDS.COM_PERSHING_NETXWEALTH_UNIVERSALSEARCH}
            rootId={APP_IDS.COM_PERSHING_NETXWEALTH_UNIVERSALSEARCH} />
        </div>
        <div data-ipc-container={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_QUOTE_BAR} >
          <F2AppContainer
            removeApp
            appId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_QUOTE_BAR}
            context={{ symbol: getSymbolFromPath(this.symbolRecvd) }}
            rootId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_QUOTE_BAR} />
        </div>
        <div className={stylesQuoteResearch.quoteAndResearch}>
          <Tabs id={'MainPage_tab'} ariaLabel={'Finanace tabs'} activeTab={'Valuations'} onClick={(k) => { changeTabHandler(k) }}>
            <div key='Snapshot' label='Snapshot' />
            <div key='charts' label='Charting' />
            <div key='Options' label='Options' />
            <div key='dividends' label='Dividends' />
            <div key='NewsAndResearch' label='News & Research' />
            <div key='Valuations' label='Valuations'>
              <div className={stylesQuoteResearch.stockValuationContainer}>
                <div className={stylesQuoteResearch.leftSectionContainer} >
                  <div data-ipc-container={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_VALUATION_MEASURES} >
                    <F2AppContainer
                      appId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_VALUATION_MEASURES}
                      context={{ symbol: getSymbolFromPath(this.symbolRecvd) }}
                      rootId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_VALUATION_MEASURES} />
                  </div>
                  <div data-ipc-container={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_PEER_VALUATIONS} >
                    <F2AppContainer
                      appId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_PEER_VALUATIONS}
                      context={{ symbol: getSymbolFromPath(this.symbolRecvd) }}
                      rootId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_PEER_VALUATIONS} />
                  </div>
                  <div data-ipc-container={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_GROWTH_MEASURES} >
                    <F2AppContainer
                      appId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_GROWTH_MEASURES}
                      context={{ symbol: getSymbolFromPath(this.symbolRecvd) }}
                      rootId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_GROWTH_MEASURES} />
                  </div>
                </div>
                <div className={stylesQuoteResearch.rightSectionContainer}>
                  <div data-ipc-container={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_LEVERAGERATIOS} >
                    <F2AppContainer
                      appId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_LEVERAGERATIOS}
                      context={{ symbol: getSymbolFromPath(this.symbolRecvd) }}
                      rootId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_LEVERAGERATIOS} />
                  </div>
                  <div data-ipc-container={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_PROFIT_MARGINS} >
                    <F2AppContainer
                      appId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_PROFIT_MARGINS}
                      context={{ symbol: getSymbolFromPath(this.symbolRecvd) }}
                      rootId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_PROFIT_MARGINS} />
                  </div>
                  <div data-ipc-container={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_EFFECTIVENESS} >
                    <F2AppContainer
                      appId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_EFFECTIVENESS}
                      context={{ symbol: getSymbolFromPath(this.symbolRecvd) }}
                      rootId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_EFFECTIVENESS} />
                  </div>
                  <div data-ipc-container={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_CASHFLOW_TRENDS} >
                    <F2AppContainer
                      appId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_CASHFLOW_TRENDS}
                      context={{ symbol: getSymbolFromPath(this.symbolRecvd) }}
                      rootId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_CASHFLOW_TRENDS} />
                  </div>
                </div>
              </div>
            </div>
            <div key='EarningsAndEstimates' label='Earnings & Estimates' />
            <div key='Fundamentals' label='Fundamentals' />
            <div key='Ownership' label='Ownership' />
          </Tabs>
        </div>
        <TokenEvents />
      </div>
    )
  }
}

export default Valuations
